import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
//import { useParams } from 'react-router-dom'
import { Panel } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import scrollToComponent from 'react-scroll-to-component'
import AddressForm from '../../../components/forms/addressForm/AddressForm'
import AddressView from '../AddressView'
import { saveAddressTemplate, updateAddressTemplate } from '../../../redux/actions/address'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSidebar } from '../../../redux/actions/sidebar'
import ButtonPanel from '../../ButtonPanel'
import { PROPOSAL, SUB_PROJECT } from '../../../constants/project'

export default function FormAddress({ schema, isEditAll, ...props }) {
  const { type, isEdit, onChangeIsEdit, showCommandButton, isSubProject } = props
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(schema)

  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      let response

      if (request.id) {
        response = await updateAddressTemplate(
          request,
          projectId,
          request.id,
          type,
          isSubProject ? SUB_PROJECT : PROPOSAL
        )
      } else {
        response = await saveAddressTemplate(
          request,
          projectId,
          type,
          isSubProject ? SUB_PROJECT : PROPOSAL
        )
      }

      setFormSchema(response)
      onChangeIsEdit(false)
      await dispatch(getSchemaSidebar(projectId))
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('onSubmit', data)

    const request = {
      id: formSchema.id,
      projectVersionId: projectId,
      addressName: data.addressName,
      directorName: data.directorName,
      buildingName: data.buildingName,
      roomNumber: data.roomNumber,
      houseNumber: data.houseNumber,
      villageNumber: data.villageNumber,
      lane: data.lane,
      villageName: data.villageName,
      road: data.road,
      location: data.location,
      telephone: data.telephone,
      mobile: data.mobile,
      fax: data.fax,
      email: data.email,
      urbanType: data.urbanType,
    }

    // console.log('request', request)
    handleCallService(request)
  }

  return (
    <>
      <Panel
        shaded
        header={formSchema.title}
        bordered
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {isEdit && showCommandButton ? (
          <AddressForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          ></AddressForm>
        ) : (
          <div>
            <AddressView data={formSchema} />
          </div>
        )}

        {showCommandButton && (
          <>
            <hr />
            <ButtonPanel
              isDisabled={isLoading}
              isEdit={isEdit}
              isError={isError}
              buttonText={formSchema.buttonText || formSchema.title}
              onSave={handleSubmit(onSubmit)}
              onCancel={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
              }}
              onEdit={() => {
                setIsError(false)
                onChangeIsEdit(!isEdit)
                scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
              }}
            />
          </>
        )}
      </Panel>
    </>
  )
}
